import * as React from 'react';
import { StyleRulesCallback, WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import {
  AnsweredCluster,
  AnsweredQuestionDto,
  AnsweredQuestionnaireDto
} from '../../../pages/answeredQuestionnaireTypes';
import AnsweredQuestion from './AnsweredQuestion';
import { Divider } from '@material-ui/core';
import Cluster from '../common/Cluster';
import { sortAsc } from '../../../util/sorting';

interface Props {
  answeredCluster: AnsweredCluster,
  questionnaireId: number,
  enableComment: boolean,
  updateQuestionnaire: (updatedQuestionnaire: AnsweredQuestionnaireDto) => void
}

type LocalStyles = 'divider';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  divider: {
    margin: theme.spacing.unit
  },
});

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class QuestionCluster extends React.Component<PropsWithStyle> {

  constructor(props: PropsWithStyle) {
    super(props);
    this.renderQuestions = this.renderQuestions.bind(this);
  }

  public render() {
    return (
     <Cluster
       cluster={this.props.answeredCluster}
       renderQuestions={this.renderQuestions}/>
    )
  }

  private renderQuestions() {
    return (
      <>
        {
          this.props.answeredCluster.questions
            .slice()
            .sort((c1, c2) => sortAsc(c1, c2))
            .map((question, index) => (
              this.renderQuestion(question, index)
            )
          )
        }
      </>
    )
  }

  private renderQuestion(question: AnsweredQuestionDto, indexOfQuestion: number) {
    const lastQuestion = indexOfQuestion === this.props.answeredCluster.questions.length - 1;
    return (
      <div key={question.id + 'container'}>
        <AnsweredQuestion key={question.id} enableComment={this.props.enableComment}
                          updateQuestionnaire={this.props.updateQuestionnaire}
                          answeredQuestion={question}
                          questionnaireId={this.props.questionnaireId}/>
        {
          !lastQuestion &&
          <Divider key={question.id + 'devider'} className={this.props.classes.divider}/>
        }
      </div>
    )
  }
}

export default withStyles(localStyles)(QuestionCluster);
